import { render } from "./Pagination.vue?vue&type=template&id=669161cc"
import script from "./Pagination.js?vue&type=script&lang=js"
export * from "./Pagination.js?vue&type=script&lang=js"

import "./Pagination.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__